let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1Rj1s")).then(() => parcelRequire('9OVx5'));